export default __webpack_public_path__ + "static/media/salida-de-emergencia.638def40.png";